import { render } from "./IngredientNav.vue?vue&type=template&id=371c6695"
import script from "./IngredientNav.vue?vue&type=script&lang=js"
export * from "./IngredientNav.vue?vue&type=script&lang=js"

import "./IngredientNav.vue?vue&type=style&index=0&id=371c6695&lang=css"

import exportComponent from "/var/www/staging.no-menu.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__